<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Análises — Todas as análises: Listagem e exibição
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  listar
        |  e
        strong  abrir
        |  análises de
        strong  todo o departamento
        | , no menu
        strong  Análises → Todas as análises
        | .

      .toast.toast-primary
        | A listagem exige a permissão
        strong  Ordem serviços → Análise → Análises → Listar
        | .

      h5.h5 1. Abrir Todas as análises
      ol
        li No menu lateral, clique em
          strong  Análises
          | .
        li Clique em
          strong  Todas as análises
          | .
      p A lista carrega ao abrir a tela e mostra análises de todos os analistas do departamento.

      h5.h5 2. Filtros e listagem
      figure.manual-figure
        img(:src="imgLista" alt="Listagem Todas as análises com cards")
      p Além dos filtros de Minhas análises, você pode filtrar por:
      ul
        li
          strong Analista
        li
          strong Por conclusão
          |  (concluídas / não concluídas)
        li
          strong Grupo do analista
        li
          strong Fiscal da OS-m
          |  e
          strong  grupo do fiscal
        li
          strong Apenas avulsas
      ol
        li Ajuste os critérios (use a engrenagem para habilitar mais campos).
        li Clique na
          strong  lupa
          |  para pesquisar.
      p Os resultados aparecem em
        strong  cards
        |  (analista, situação, assunto, OS-m, protocolo, cadastro). No rodapé de cada card, use
        strong  Exibir
        | .

      h5.h5 3. Abrir a análise
      ol
        li Clique em
          strong  Exibir
          |  no card desejado.
        li O sistema abre o detalhe da análise.

      .toast.toast-primary
        | A exibição exige a permissão
        strong  Ordem serviços → Análise → Análises → Exibir
        | .

      h5.h5 4. Tela de exibição
      figure.manual-figure
        img(:src="imgShow" alt="Exibição de uma análise em Todas as análises")
      p O detalhe é o mesmo painel compartilhado: cabeçalho com situação e OS-m, eventos, dados da OS-m, checklist e
        strong  Ver OS-m
        |  /
        strong  Imprimir
        | .
      p Ações de gestão (trocar analista, cancelar) dependem de permissão e não fazem parte deste manual de listagem e exibição.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/11-analises-todas-lista.png"),
      imgShow: require("@/assets/manuais/11a-analises-todas-show.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
